import React from "react";

const HviContentEn = () => {

    return (
        <div>
            <div className="mb-4">
                <h4 className="fw-bold mb-3">Our Human Well-being Index increases your awareness about your personal sustainability, performance and well-being.</h4>
                <p>By answering twelve questions in five minutes, you get an indication of how sustainable your everyday life is. The questions are designed to give you an impression of how you are doing right now, and an opportunity to reflect on how you can make things better. Over time, you can track how well you succeed in living a more sustainable life every day.</p>
            </div>

            <div className="mb-4">
                <h4 className="fw-bold mb-3">Your answers get organized into a red-yellow-green scale:</h4>
                <p><span className="bg-sy-red px-2 py-1 me-1 text-white rounded-2">Red (12-24)</span>: Indicates an unsustainable lifestyle and an elevated risk of future illnesses. You are in a bad place and need to do something about it not to endanger your health.</p>
                <p><span className="bg-sy-yellow px-2 py-1 me-1 text-white rounded-2">Yellow (25-59)</span>: Indicates that parts of your everyday life are unsustainable and that you swing from back and forth between a risky and healthy position. By making some changes, you can take control and make your life more sustainable.</p>
                <p><span className="bg-dark-green px-2 py-1 me-1 text-white rounded-2">Green (60-72)</span>: Indicates a sustainable everyday life and overall well-being. You're in a healthy place.</p>
                <p>Your responses will be kept confidential!</p>
            </div>
        </div>
    )

}

export default HviContentEn;